import { Module } from "vuex";

export const Sanctrions: Module<any, any> = {
  state: {
    // querySearch: {},
    checkOpen: false,
    currentPage: {},
    checkLink: "",
  },
  getters: {
    // querySearch: (state) => state.query,
  },
  mutations: {
    // setcurrentPage(state, data) {
    //   state.currentPage = data;
    // },
    // // setquerySearch(state, data) {
    // //   state.querySearch = data;
    // // },
    // setcheckOpen(state, data) {
    //   state.checkOpen = data;
    // },
    // setcheckLink(state, data) {
    //   state.checkLink = data;
    // },
  },
  actions: {
    // setcurrentPage(data) {
    //   console.log(data);
    //   data.commit("setcurrentPage");
    // },
    // setquerySearch(query) {
    //   query.commit("setquerySearch");
    // },
    // setcheckOpen(check) {
    //   check.commit("setcheckOpen");
    // },
    // setcheckLink(check) {
    //   check.commit("setcheckLink");
    // },
  },
};
